import React, { type FunctionComponent } from 'react';
import styles from './DateHighlight.module.css';

type DateHighlightProps = {
    date: string;
    month: string;
};

export const DateHighlight: FunctionComponent<DateHighlightProps> = ({ date, month }) => {
    return (
        <div className={styles.date_highlight_container}>
            <span className={styles.month_big}>{month}</span>
            <span className={styles.date_big}>{date}</span>
        </div>
    );
};
